export default {
  user: null,
  customerBalance: null,
  walletBalance: null,
  customerPlan: null,
  allPlan: null,
  tablePrice: null,
  clientKey: null,
  audioInfo: null,
  fileInfo: null,
  playing: false,
  allPlay: false,
  currentAudioId: null,
  selectedProject: null,
  snackbars: {
    success: false,
    error: false,
    warning: false,
  },
  timeout: 3000,
  info: {
    success: "",
    error: "",
    warning: "",
  },
  synth_state: {
    status: "read",
    total: 0,
    synthesized: 0,
  },
  focusedFileId: null,
  warningFileDialog: false,
};
